export default "__VITE_ASSET__Dan6UThv__"